import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { SwiftlaneUserGroup } from './get-swiftlane-user-groups'

type GetSwiftlaneResidentRequest = {
  buildingId: number
  userId: string
}

export type SwiftlaneResident = {
  groups: SwiftlaneUserGroup[]
  expirationDate: string | null
}

export const getSwiftlaneResidentQueryKey = (data: GetSwiftlaneResidentRequest) => [
  'useGetSwiftlaneResident',
  data,
]

const getSwiftlaneResident = async (data: GetSwiftlaneResidentRequest) => {
  const response = await authAPI.get<SwiftlaneResident>(
    `/building/${data.buildingId}/swiftlane/resident/${data.userId}`,
  )
  return response.data
}

export const useGetSwiftlaneResident = (data: GetSwiftlaneResidentRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId) && Boolean(data.userId),
    queryFn: () => getSwiftlaneResident(data),
    queryKey: getSwiftlaneResidentQueryKey(data),
  })
